import { render, staticRenderFns } from "./LiteralValue.vue?vue&type=template&id=1e87c809&"
import script from "./LiteralValue.vue?vue&type=script&lang=js&"
export * from "./LiteralValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports